import PropTypes from "prop-types"
import helpIconRaw from "images/icons/help.svg?raw"
import parse from "html-react-parser"

import styles from "./warning_message.module.scss"

export default function WarningMessage({ message }) {
  if (!message) return null

  return (
    <span className={styles["warning-message"]}>
      <span className={styles["warning-icon"]}>{parse(helpIconRaw)}</span>
      <span>{message}</span>
    </span>
  )
}

WarningMessage.propTypes = {
  message: PropTypes.string,
}
